import React from "react";
import Dashboard from "./Dashboard.js";
import "./DashboardCommon.css";

const AgeDashboard = ({ dataList }) => {
  return (
    <>
      <div className="header_flex">
        <h4 className="header_title">Age</h4>
      </div>
      <div className="dashboard_div">
        <Dashboard
          type="2"
          ListType={""}
          monthList={dataList?.ageRanges || []}
          weekList={[]}
          dayList={[]}
        />
      </div>
      <div className="divider_div4" />
    </>
  );
};

export default AgeDashboard;
